import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const documentRichMedia: NodeRenderer = (node, children) => (
  <div className="line-clamp-3 h-[75px] overflow-hidden overflow-ellipsis">
    {children}
  </div>
)
